<template>
  <div class="c-row" :class="{ disabled: setting.disabled }">
    <div class="c-left">
      <div class="c-item">{{ setting.title }}</div>
      <div class="c-explain">{{ setting.explain }}</div>
      <template v-if="!leTbS">
        <div class="s"></div>
        <div class="c-supplement">{{ setting.supplement }}</div>
      </template>
    </div>
    <div class="c-right">
      <template v-if="!setting.hideValue">
        <template v-if="setting.type === 'cover'">
          <select-cover
            :cid="selectedCommunity.id"
            :type="settingKey == 'community_cover' ? 'community' : 'profile'"
            :coverPath="setting.value"
            @onCoverSelected="onCoverSelected"
            :disabled="setting.disabled"
            :addTitle="false"
          />
        </template>

        <template v-else-if="setting.type === 'switch'">
          <template v-if="value"
            ><div class="c-status active">{{ $T('param.on') }}</div></template
          >
          <template v-else
            ><div class="c-status">{{ $T('param.off') }}</div></template
          >
          <div class="c-button c-switch">
            <v-switch color="clr-primary" v-model="value" hide-details :disabled="setting.disabled" />
          </div>
        </template>

        <template v-else-if="setting.type === 'value-button'">
          <template v-if="setting.value">
            <div class="c-status c-min active">
              <!-- v-html: editValue may return a clr-danger span for over-limit values (trusted FE formatting of numbers/master data, never user input) -->
              <template v-if="setting.editValue"
                ><div v-html="setting.editValue(this, setting.value)"></div></template
              >
              <template v-else>{{ setting.value }}</template>
            </div>
          </template>
          <template v-else>
            <div class="c-status">{{ $T('param.none') }}</div>
          </template>
          <div class="c-button">
            <v-btn color="clr-secondary" outline small :disabled="setting.disabled" @click.stop="clickButton">{{
              $T('button.modify')
            }}</v-btn>
          </div>
        </template>

        <template v-else-if="setting.type === 'button'">
          <div class="c-button only">
            <v-btn
              :color="setting.danger ? 'danger' : 'secondary'"
              outline
              small
              :disabled="setting.disabled"
              @click.stop="clickButton"
              >{{ setting.btnname }}</v-btn
            >
          </div>
        </template>

        <template v-else-if="setting.type === 'radio'">
          <div class="c-button-wide">
            <v-radio-group v-model="value" hide-details :disabled="setting.disabled">
              <v-radio
                v-for="item in setting.items"
                color="clr-primary"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :class="{ 'v-radio--is-disabled': item.disabled }"
                hide-details
              />
            </v-radio-group>
          </div>
        </template>

        <template v-if="setting.type === 'none'">
          <div class="c-text-only">
            <!-- v-html: editValue may return a clr-danger span for over-limit values (trusted FE formatting of numbers/master data, never user input) -->
            <span v-if="setting.editValue" v-html="setting.editValue(this, setting.value)"></span>
            <span v-else>{{ setting.value }}</span>
          </div>
        </template>
      </template>
    </div>
    <div v-if="leTbS" class="c-supplement">{{ setting.supplement }}</div>
  </div>
</template>

<script>
import selectCover from '../common/SelectCover.vue';

export default {
  components: {
    'select-cover': selectCover,
  },
  props: {
    settingIndex: Number,
    settingKey: String,
    setting: Object,
  },
  data() {
    return {
      value: this.setting.value,
      disabled: this.setting.disabled,
      supplement: this.setting.supplement,
    };
  },
  methods: {
    setValue(value) {
      this.value = value;
    },
    setDisabled(value) {
      this.disabled = value;
    },
    setSupplement(value) {
      this.supplement = value;
    },
    clickButton() {
      this.$emit('click-button', this.settingKey);
    },
    resetValue() {
      this.value = this.setting.value;
    },
    onCoverSelected(selectCoverVue) {
      this.$emit('change-cover', this.settingKey, selectCoverVue);
    },
  },
  watch: {
    value: function(newParam, oldParam) {
      if (this.setting.value != newParam) {
        this.$emit('change-value', this.settingKey, newParam, oldParam);
      }
    },
  },
};
</script>

<style scoped>
.c-status {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
</style>
